import { useMemo } from 'react';
import { getFieldsConfig, renderField, getFieldIcon } from '../config/propertyFields';

/**
 * Hook for managing property fields configuration
 * @param {Object} investmentData - Investment data from database
 * @param {string} widgetType - 'list' or 'card'
 * @returns {Object} Fields configuration and render functions
 */
export const usePropertyFields = (investmentData, widgetType = 'card') => {
  const fieldConfigs = useMemo(() => {
    return getFieldsConfig(investmentData, widgetType);
  }, [investmentData, widgetType]);

  const renderPropertyField = (fieldConfig, property) => {
    const { field, params } = fieldConfig;
    return renderField(field, property, widgetType, params);
  };

  return {
    fieldConfigs,
    renderPropertyField,
    getFieldIcon: (fieldConfig) => getFieldIcon(fieldConfig.field)
  };
};
